module.exports = __webpack_public_path__ + "img/W-34.a200d4ac.jpg";